import { config } from 'config';
import { autobind } from 'core-decorators';
import { computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { Link } from 'react-router-dom';
import { AchievementApi } from '@intelingu/core/api/AchievementApi';
import { CurrentProgressResponse, ProgressApi } from '@intelingu/core/api/ProgressApi';
import { COMMON_NS } from '@intelingu/core/constants/base.constants';
import { AchievementModel } from '@intelingu/core/interfaces/models/AchievementModel';
import { lazyInject } from '@intelingu/core/IoC/container';
import { CourseStore } from '@intelingu/core/stores/CourseStore';
import classnames from 'classnames';
import { UserStore } from '@intelingu/core/stores/UserStore';
import withTranslation from '@intelingu/core/utils/withTranslation';
import { ConfirmEmailComponent } from './ConfirmEmailComponent';
import {SubscriptionStore} from "@intelingu/core/stores/SubscriptionStore";
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import {BootstrapStore} from "../../../../stores/BootstrapStore";
import {UserApi} from "@intelingu/core/api/UserApi";
import {AchievementIcon} from "./AchievementIcon";

export interface IndexPageProps {
    t?;
}

@withTranslation(COMMON_NS)
@observer export class IndexPage extends Component<IndexPageProps, any> {

    @lazyInject(ProgressApi) progressApi: ProgressApi;
    @lazyInject(CourseStore) courseStore: CourseStore;
    @lazyInject(AchievementApi) achievementApi: AchievementApi;
    @lazyInject(UserStore) userStore: UserStore;
    @lazyInject(SubscriptionStore) subscriptionStore: SubscriptionStore;
    @lazyInject(BootstrapStore) bootstrapStore: BootstrapStore;
    @lazyInject(UserApi) userApi: UserApi;

    @observable milestoneProgress = 0;
    @observable progress: CurrentProgressResponse;
    @observable achievements: AchievementModel[] = [];
    @observable legDots = [];
    @observable isDisableModalVisible = false;

    @observable width;

    @computed get days() {
        const {
            next_position,
            current_position,
            offset,
            average_cards
        } = this.progress;

        return Math.max(0, Math.round((next_position - offset) / average_cards));
        // return Math.max(0, Math.round((next_position - (offset - current_position)) / average_cards));
    }

    async componentDidMount() {
        if (!this.bootstrapStore.skipFirstLoad) {
            const response = await this.userApi.bootstrap(['progress', 'achievements']);

            this.userStore.achievements = response.data.achievements;
            this.userStore.progress = response.data.progress;
        } else {
            this.bootstrapStore.skipFirstLoad = false;
        }

        this.achievements = this.userStore.achievements;
        this.progress = this.userStore.progress;

        /*const {
            milestone: { level },
            offset
        } = this.progress;

        const unlearnedVocabularies = (level * config.milestoneCards) - offset;
        this.milestoneProgress = Math.round((unlearnedVocabularies / config.milestoneCards) * 100);*/

        const totalDots = 16;
        const learnedNumber = this.progress.offset > this.progress.next_position ?
            this.progress.next_position :
            this.progress.offset - this.progress.current_position;

        const fillDotsPercent = (learnedNumber / this.progress.next_position) * 100;
        const fillDots = Math.round((fillDotsPercent / 100) * totalDots);

        for (let i = 0; i < totalDots; i++) {
            this.legDots.push(<i key={i} className={classnames('dot', { 'fill': i < fillDots })} />)
        }

        /*setTimeout(() => {
            const progressValue: any = document.querySelector('.progress__value');

            const RADIUS = 54;
            const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

            function progress(value) {
                const progress = value / 100;
                const dashoffset = CIRCUMFERENCE * (1 - progress);

                progressValue.style.strokeDashoffset = dashoffset;
            }

            progressValue.style.strokeDasharray = CIRCUMFERENCE;
            progress(this.milestoneProgress);
        });*/

        window.addEventListener('resize', this.onResize);
        this.onResize();
    }

    componentWillUnmount(): void {
        window.removeEventListener('resize', this.onResize);
    }

    @autobind onResize() {
        this.width = window.innerWidth;
    }

    @autobind toggleModal() {
        this.isDisableModalVisible = !this.isDisableModalVisible;
    }

    _renderLegDays() {
        const { t } = this.props;

        if (!this.progress.average_cards) {
            return null;
        }

        return <>
            <h3>{ t('homeLegH3') }:</h3>
            <h2>{ this.days } { t(this.days === 1 ? 'homeLegDay' : 'homeLegDays') }</h2>

            <p>{ t('homeLegBottomText') }</p>
        </>
    }

    render() {
        const { t } = this.props;

        if (!this.progress) {
            return null;
        }

        return <div className={'index-wrapper'}>
            <div className={'index-page'}>
                { !this.userStore.user.email_confirmed && <ConfirmEmailComponent /> }
                {/*<TrialComponent />*/}

                <div className={'row'}>
                    <div className={'col-12 col-lg-8 pr-lg-3'}>
                        <div className={'start-course-view'} style={{ backgroundImage: `url(${this.width > 600 ? this.progress.leg.image : this.progress.leg.image_portrait})` }}>
                            <div className={'overlay'} />

                            <div className={'content'}>
                                <div className={'top'}>
                                    {/*<p className={'overview'}>First words and sentences:<br />Lesson 1</p>*/}
                                    <h1 className={'mb-3'}>{ this.progress.leg.name }</h1>
                                    <div className={'description'} dangerouslySetInnerHTML={{ __html: this.progress.leg.description }} />
                                </div>
                                <div>
                                    {/*<Link to={'/course'} className={'btn btn-primary btn-lg'}>{ t('homeStartTraining') }</Link>*/}
                                    { /*this.subscriptionStore.hasActiveSubscriptions ? (
                                        <Link to={'/course'} className={'btn btn-primary btn-lg'}>{ t('homeStartTraining') }</Link>
                                    ) : (
                                        <a href={''} onClick={e => {
                                            e.preventDefault();
                                            this.toggleModal();
                                        }} className={'btn btn-primary btn-lg'}>{ t('homeStartTraining') }</a>
                                    )*/ }

                                    { this.userStore.user.email_confirmed ? (
                                        <Link to={'/course'} className={'btn btn-primary btn-lg'}>{ t('homeStartTraining') }</Link>
                                    ) : (
                                        <a href={''} onClick={e => {
                                            e.preventDefault();
                                            this.toggleModal();
                                        }} className={'btn btn-primary btn-lg'}>{ t('homeStartTraining') }</a>
                                    ) }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={'flex-1 col-12 col-lg-4 mt-3 mt-lg-0 pl-lg-0'}>
                        <div className={'info'}>
                            <h1>{ t('homeLegH1') }</h1>

                            <div className={'dots'}>
                                { this.legDots.map(item => item) }
                            </div>

                            { this._renderLegDays() }
                        </div>
                    </div>
                </div>

                {/*<div className={'col-12 col-lg-9 mt-5 info milestone'} style={{ margin: '0 auto' }}>
                    <h2>{ this.progress.milestone.name }</h2>

                    <div className={'row'}>
                        <div className={'col-12 col-md-6'}>
                            <div className="progress-wrapper">
                                <svg className="circle-progress" width="260" height="260" viewBox="0 0 130 130">
                                    <circle className="progress__meter" cx="64" cy="64" r="48" strokeWidth="14"/>
                                    <circle className="progress__value" cx="64" cy="64" r="48" strokeWidth="14"/>
                                </svg>

                                <div className={'title'}>{ this.milestoneProgress }%</div>
                            </div>
                        </div>

                        <div className={'col-12 text-center mt-4 mt-md-0 text-md-left col-md-6 align-items-sm-center description'}>
                            { this.progress.milestone.description }
                        </div>
                    </div>
                </div>*/}

                { this.achievements.length > 0 && (
                    <div className={'achievements'}>
                        <h1>{ t('homeAchievementsTitle') }</h1>

                        <div className={'row'}>
                            { this.achievements.map(item => (
                                <AchievementIcon item={item} key={item.id} />
                            )) }
                        </div>
                    </div>
                ) }
            </div>

            {/*<Modal isOpen={this.isDisableModalVisible} toggle={this.toggleModal}>
                <ModalBody>
                    Du hast derzeit keine aktive Mitgliedschaft. Buche eine Kurs-Option, um Intelingu weiter benutzen zu können.
                </ModalBody>
                <ModalFooter>
                    <Link to={'/subscriptions'} className={'btn btn-primary'}>verfügbare Kurse anzeigen</Link>
                </ModalFooter>
            </Modal>*/}

            <Modal isOpen={this.isDisableModalVisible} centered={true} toggle={this.toggleModal}>
                <ModalBody>
                    Bitte bestätige deine eMail-Adresse
                </ModalBody>
                <ModalFooter>
                    <button onClick={this.toggleModal} className={'btn btn-primary'}>Ok</button>
                </ModalFooter>
            </Modal>
        </div>
    }

}
